module.exports = __webpack_public_path__ + "img/favicon.e49dd4f7.png";